/**
 * Legacy: `critical` priority maps to `high` for existing data (color + "High" label).
 *
 * RFI Constants
 *
 * Centralized constants for RFI status and priority colors.
 * Used across RFI Log and RFI Detail components for consistent UX.
 */

// Status Colors
// New: red, Open: orange, Awaiting Response: yellow, Closed: green
export const RFI_STATUS_COLORS = {
  new: "bg-red-400",
  open: "bg-orange-400",
  awaiting_response: "bg-yellow-400 text-gray-900",
  closed: "bg-green-400",
};

// Status Colors (lighter variants for pills/badges)
export const RFI_STATUS_COLORS_LIGHT = {
  new: "bg-red-100 text-red-800",
  open: "bg-orange-100 text-orange-800",
  awaiting_response: "bg-yellow-100 text-yellow-800",
  closed: "bg-green-100 text-green-800",
};

// Status Labels
export const RFI_STATUS_LABELS = {
  new: "Open",
  open: "Reviewing",
  awaiting_response: "Awaiting Response",
  closed: "Closed",
};

// Priority Colors
// Low: green, Medium: yellow, High: orange
export const RFI_PRIORITY_COLORS = {
  low: "bg-green-100 text-green-800",
  medium: "bg-yellow-100 text-yellow-800",
  high: "bg-orange-100 text-orange-800",
  // Legacy: critical support for existing data (maps to high)
  critical: "bg-orange-100 text-orange-800",
};

// Priority Labels
export const RFI_PRIORITY_LABELS = {
  low: "Low",
  medium: "Medium",
  high: "High",
  // Legacy: critical support for existing data (displays as High)
  critical: "High",
};
